import * as React from "react";

const Check = (props) => (
  <div className="w-[50px] h-[50px] flex items-center justify-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path fill="transparent" d="M0 0h24v24H0z" />
      <path
        fill={props.dark ? 'white' : "#323232"}
        fillRule="evenodd"
        d="M7.25 2.388C8.55 2.099 10.124 2 12 2s3.451.1 4.75.388c1.31.291 2.399.788 3.236 1.626.838.837 1.335 1.926 1.626 3.236C21.901 8.55 22 10.124 22 12s-.1 3.451-.388 4.75c-.291 1.31-.788 2.399-1.626 3.236-.837.838-1.926 1.335-3.236 1.626-1.299.289-2.874.388-4.75.388s-3.451-.1-4.75-.388c-1.31-.291-2.399-.788-3.236-1.626-.838-.837-1.335-1.926-1.626-3.236C2.099 15.45 2 13.876 2 12s.1-3.451.388-4.75c.291-1.31.788-2.399 1.626-3.236.837-.838 1.926-1.335 3.236-1.626Zm8.457 6.905a1 1 0 0 1 0 1.414l-3.683 3.683a1.449 1.449 0 0 1-2.048 0L11 13.366 9.976 14.39l-1.683-1.683a1 1 0 1 1 1.414-1.414L11 12.586l3.293-3.293a1 1 0 0 1 1.414 0Z"
        clipRule="evenodd"
      />
    </svg>
  </div>
);
export default Check;
